import { render, staticRenderFns } from "./SelectTaxes.vue?vue&type=template&id=a53c2f1e&scoped=true"
import script from "./SelectTaxes.vue?vue&type=script&lang=js"
export * from "./SelectTaxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53c2f1e",
  null
  
)

export default component.exports